import FJCheckBox from '../FJCheckBox/FJCheckBox';
import CloseIcon from '../../../assets/svg/close.svg?react';
import DownloadIcon from '../../../assets/svg/download.svg?react';
import DeleteBlackIcon from '../../../assets/svg/delete-black.svg?react';
import styles from './FJSelectAll.module.less';
import FJIconButton from '../FJIconButton/FJIconButton';
import classNames from 'classnames';
import FJLocalStore from '../../../store/FJLocalStore';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import ApplyIcon from '../../../assets/svg/apply.svg?react';
import AddMediaIcon from '../../../assets/svg/add-to-media.svg?react';
import FJToolTip from '../FJToolTip/FJToolTip.jsx';
import FJConstant from '../../../constants/FJConstant.js';
import FJAppConstant from '../../../constants/FJAppConstant.js';
import { FJButtonType } from '../FJButton/FJButton.jsx';
import FJPrivacySetting from '../../../components/FJCommunity/FJCommonComponent/FJPrivacySetting/FJPrivacySetting.jsx';
import FJShareSettingIcon from '../../../assets/svg/community/publish.svg?react';
import FJCommunityUtil from '../../../util/FJCommunityUtil.js';
import FJVideoEditIcon from '../../../assets/svg/community/trim-video-Edit-black.svg?react';
import { PUBLISH_TYPE } from '../../../config/dataConfig/FJCommunityData.js';

const FJSelectAll = props => {
    const {
        appType,
        list,
        selectList,
        multiDownload,
        multiDelete,
        setSelectList,
        batchDownloadLoading,
        onPrivacySettingChange,
        addAsEditPageModalBtuStatus,
        hideDownload = false,
        useApplyButton = false,
        onApply,
        onAddToMediaLibrary,
        isShowAddToMediaButton = false,
        isShowAddToEditPageButton = false,
        isMultipleMode = false,
        clearSelected,
        addAsEditPage,
        selectedText,
    } = props;
    const isShow = selectList.length > 0 || isMultipleMode;
    const selectNumber = selectList.length;
    const isTextToSpeech = appType === FJConstant.TEXT_TO_SPEECH;

    const showApplyButton = useApplyButton && selectNumber === 1;
    const isShowPrivacySetting = FJCommunityUtil.isUseNewPreviewModal(appType);
    const multiPrivacy = useMemo(() => {
        if (list && list.length > 0) {
            const values = Array.from(
                new Set(list.filter(item => selectList.includes(item.id)).map(item => item.privacyStatus)),
            );
            return values.length > 1 ? '' : values.join();
        }
        return '';
    }, [list, selectList]);
    const filterList = useMemo(
        () => list.filter(i => (i.status ? i.status !== 'progress' && i.status !== 'processing' : true)),
        [list],
    );
    const filterCanUseList = useMemo(
        () => list.filter(i => (i.status ? i.status === 'completed' || i.status === 'succeeded' : true)),
        [list],
    );

    const _clearSelected = () => {
        clearSelected && clearSelected();
        setSelectList([]);
    };
    const isSelectedAll = selectList?.length >= filterList?.length;
    const _selectAll = () => {
        if (isSelectedAll) {
            setSelectList([]);
        } else {
            setSelectList(filterList.map(i => (isTextToSpeech ? i?.pid : i?.id)));
        }
    };
    const _onBatchDownload = () => {
        if (batchDownloadLoading) {
            return;
        }
        multiDownload && multiDownload(selectList, 'multiple choose');
    };

    const isVideo =
        appType === FJAppConstant.AI_VIDEO_GENERATOR ||
        appType === FJAppConstant.VIDEO_REMOVE_BG ||
        appType === FJAppConstant.AI_VIDEO_DUB;
    const isAudioGenerator = appType === FJAppConstant.AI_AUDIO_GENERATOR;

    const isDisabledOfDownload = useMemo(() => {
        if (isVideo || isAudioGenerator) {
            try {
                return (
                    selectList.filter(i => filterList.find(j => j.id === i && j.status === 'failed')).length ===
                    selectList.length
                );
            } catch (e) {
                return false;
            }
        } else {
            return false;
        }
    }, [isVideo, isAudioGenerator, selectList, filterList]);

    const isDisabledOfAddToMedia = useMemo(() => {
        if (isVideo || isAudioGenerator) {
            try {
                return (
                    selectList.filter(i => filterList.find(j => j.id === i && j.status === 'failed')).length ===
                    selectList.length
                );
            } catch (e) {
                return selectList.length === 0;
            }
        } else {
            return selectList.length === 0;
        }
    }, [isVideo, isAudioGenerator, selectList, filterList]);

    const _onAddToMediaLibrary = () => {
        if (!onAddToMediaLibrary) return;
        const selectedList = filterCanUseList.filter(item => selectList.includes(item.id));
        const sList = selectedList.map(item =>
            isAudioGenerator ? item.audioUrl : isVideo ? item.videoUrl : item.imgUrl,
        );
        onAddToMediaLibrary(sList);
    };

    const _onAddToEditPage = () => {
        if (!addAsEditPage) return;
        const selectedList = filterCanUseList.filter(item => selectList.includes(item.id));
        addAsEditPage && addAsEditPage(selectedList.map(i => i.id));
    };

    const _onApplyMedia = () => {
        if (!onApply) return;

        const selectedId = selectList[0];
        const selectedItem = filterCanUseList.find(item => item.id == selectedId);
        if (selectedItem) {
            onApply(isAudioGenerator ? selectedItem.audioUrl : isVideo ? selectedItem.videoUrl : selectedItem.imgUrl);
        }
    };

    const _getSelectText = () => {
        if (selectedText) {
            return selectedText;
        }
        if (isVideo) {
            return selectNumber > 1 ? FJLocalStore._('videos-selected') : FJLocalStore._('video-selected');
        } else if (isAudioGenerator) {
            return FJLocalStore._('music-selected');
        } else {
            return selectNumber > 1 ? FJLocalStore._('files-selected') : FJLocalStore._('file-selected');
        }
    };

    const _onPrivacySettingChange = (value, callback) => {
        const items = filterList.filter(
            item => selectList.includes(item.id) && item.privacyStatus !== PUBLISH_TYPE.DOWN,
        );
        onPrivacySettingChange && onPrivacySettingChange(items, value, callback);
    };

    const _renderButtonForEditPage = () => {
        return (
            <>
                {!hideDownload && (
                    <>
                        <FJToolTip title={'download'}>
                            <div style={{ marginRight: 12 }}>
                                <FJIconButton
                                    icon={<DownloadIcon />}
                                    type={FJButtonType.GRADIENT}
                                    text={FJLocalStore._('download')}
                                    onClick={_onBatchDownload}
                                    style={{ padding: '0 26px' }}
                                    isLoading={batchDownloadLoading}
                                    loadingSize={16}
                                    disabled={isDisabledOfDownload}
                                />
                            </div>
                        </FJToolTip>
                        <div className={styles.split_line} />
                    </>
                )}
                {isShowPrivacySetting && (
                    <FJPrivacySetting
                        value={multiPrivacy}
                        onChange={_onPrivacySettingChange}
                        hideShareToSociety={true}
                        renderTrigger={({ ref, onClick }) => {
                            return (
                                <FJToolTip title='visibility'>
                                    <div style={{ marginRight: 12 }} ref={ref} onClick={onClick}>
                                        <FJIconButton
                                            icon={<FJShareSettingIcon />}
                                            style={{ padding: 0, width: 40, height: 40 }}
                                            disabled={selectList.length === 0}
                                        />
                                    </div>
                                </FJToolTip>
                            );
                        }}
                    />
                )}
                <FJToolTip title={'delete'}>
                    <div style={{ marginRight: 12 }}>
                        <FJIconButton
                            icon={<DeleteBlackIcon />}
                            onClick={() => multiDelete(selectList)}
                            style={{ padding: 0, width: 40, height: 40 }}
                            disabled={selectList.length === 0}
                        />
                    </div>
                </FJToolTip>

                {isShowAddToMediaButton && (
                    <FJIconButton
                        textClassName={styles.button_text}
                        text={FJLocalStore._(showApplyButton ? 'apply' : 'add-to-media')}
                        icon={showApplyButton ? <ApplyIcon /> : <AddMediaIcon />}
                        type={'gradient'}
                        onClick={showApplyButton ? _onApplyMedia : _onAddToMediaLibrary}
                        disabled={isDisabledOfAddToMedia}
                    />
                )}
            </>
        );
    };

    const _renderButton = () => {
        return (
            <>
                {!hideDownload && (
                    <>
                        <FJToolTip title={'download'}>
                            <div>
                                <FJIconButton
                                    icon={<DownloadIcon />}
                                    type={FJButtonType.GRADIENT}
                                    onClick={_onBatchDownload}
                                    text={FJLocalStore._('download')}
                                    style={{ padding: '0 26px' }}
                                    isLoading={batchDownloadLoading}
                                    loadingSize={16}
                                    disabled={isDisabledOfDownload}
                                />
                            </div>
                        </FJToolTip>
                        <div className={styles.split_line} />
                    </>
                )}
                {isShowPrivacySetting && (
                    <FJPrivacySetting
                        value={multiPrivacy}
                        onChange={_onPrivacySettingChange}
                        hideShareToSociety={true}
                        renderTrigger={({ ref, onClick }) => {
                            return (
                                <FJToolTip title='visibility'>
                                    <div style={{ marginRight: 12 }} ref={ref} onClick={onClick}>
                                        <FJIconButton
                                            icon={<FJShareSettingIcon />}
                                            style={{ padding: 0, width: 40, height: 40 }}
                                        />
                                    </div>
                                </FJToolTip>
                            );
                        }}
                    />
                )}
                <FJToolTip title={'delete'}>
                    <div style={{ marginRight: 12 }}>
                        <FJIconButton
                            icon={<DeleteBlackIcon />}
                            onClick={() => multiDelete(selectList)}
                            style={{ padding: 0, width: 40, height: 40 }}
                            disabled={selectList.length === 0}
                        />
                    </div>
                </FJToolTip>

                {isShowAddToEditPageButton && (
                    <FJIconButton
                        className={styles.video_edit_btn}
                        textClassName={styles.button_text}
                        text={FJLocalStore._('edit')}
                        icon={<FJVideoEditIcon />}
                        strokeColor={'#fff'}
                        onClick={_onAddToEditPage}
                        disabled={isDisabledOfAddToMedia}
                        isLoading={addAsEditPageModalBtuStatus === FJConstant.LOADING}
                    />
                )}
            </>
        );
    };

    return (
        <div className={classNames(styles.select_all_box, isShow ? styles.show : styles.hide)}>
            <FJCheckBox dataChange={_selectAll} selected={isSelectedAll} value={FJLocalStore._('select-all')} />
            <div className={styles.middle}>
                <div className={styles.select_number}>{selectNumber}</div>

                <div className={styles.select_desc}>{_getSelectText()}</div>
                <div className={styles.split_line} />
                {window.isEditPage ? _renderButtonForEditPage() : _renderButton()}
            </div>
            <div className={styles.close_btn_box} onClick={_clearSelected}>
                <CloseIcon className={styles.close_icon} />
            </div>
        </div>
    );
};
FJSelectAll.propTypes = {
    appType: PropTypes.string,
    list: PropTypes.array,
    selectList: PropTypes.array,
    multiDownload: PropTypes.func,
    multiDelete: PropTypes.func,
    setSelectList: PropTypes.func,
    batchDownloadLoading: PropTypes.bool,
    hideDownload: PropTypes.bool,
    clearSelected: PropTypes.func,
};
export default FJSelectAll;
